"use client";

import { motion } from "framer-motion";
import Image from "next/image";

const HomeGetInTouch = () => {
  const clientLogos = [
    "/assets/photos/clients/1.png",
    "/assets/photos/clients/2.png",
    "/assets/photos/clients/3.png",
    "/assets/photos/clients/4.png",
    "/assets/photos/clients/5.png",
    "/assets/photos/clients/6.png",
    "/assets/photos/clients/7.png",
    "/assets/photos/clients/8.png",
    "/assets/photos/clients/9.png",
    "/assets/photos/clients/10.png",
    "/assets/photos/clients/11.png",
    "/assets/photos/clients/12.png",
    "/assets/photos/clients/13.png",
    "/assets/photos/clients/14.png",
    "/assets/photos/clients/15.png",
    "/assets/photos/clients/16.png",
    "/assets/photos/clients/17.png",
    "/assets/photos/clients/18.png",
    "/assets/photos/clients/19.png",
    "/assets/photos/clients/20.png",
    "/assets/photos/clients/21.png",
    "/assets/photos/clients/22.png",
    "/assets/photos/clients/23.png",
    "/assets/photos/clients/24.png",
    "/assets/photos/clients/25.png",
    "/assets/photos/clients/26.png",
    "/assets/photos/clients/27.png",
    "/assets/photos/clients/28.png",
  ];

  return (
    <section
      className="min-h-[80vh] bg-gray-100 flex items-center justify-center py-12 px-4"
      style={{
        backgroundImage: `url(/assets/photos/home/containers.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between w-full max-w-7xl gap-8">
        {/* Left Side - Three Vertical Columns of Scrolling Client Logos */}
        <div className="w-full md:w-2/5 lg:w-1/3 flex justify-between items-center gap-4">
          <div className="w-1/3 h-96 md:h-[500px] overflow-hidden relative flex-1">
            <div className="absolute top-0 left-0 right-0 h-10 bg-gradient-to-b from-gray-100 to-transparent z-10"></div>
            <div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-gray-100 to-transparent z-10"></div>
            <motion.div
              className="flex flex-col items-center space-y-6"
              initial={{ y: 0 }}
              animate={{ y: "-50%" }}
              transition={{
                duration: 20,
                repeat: Infinity,
                repeatType: "loop",
                ease: "linear",
              }}
            >
              {[...clientLogos, ...clientLogos].map((logo, index) => (
                <motion.div
                  key={`col1-${index}`}
                  className="w-30 h-20 bg-white flex items-center justify-center shadow-md rounded-lg p-2"
                  whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                >
                  <Image
                    src={logo}
                    alt={`Client logo ${index + 1}`}
                    width={100}
                    height={60}
                    className="object-contain max-w-full max-h-full"
                  />
                </motion.div>
              ))}
            </motion.div>
          </div>

          <div className="w-1/3 h-96 md:h-[500px] overflow-hidden relative flex-1">
            <div className="absolute top-0 left-0 right-0 h-10 bg-gradient-to-b from-gray-100 to-transparent z-10"></div>
            <div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-gray-100 to-transparent z-10"></div>
            <motion.div
              className="flex flex-col items-center space-y-6"
              initial={{ y: "-50%" }}
              animate={{ y: 0 }}
              transition={{
                duration: 20,
                repeat: Infinity,
                repeatType: "loop",
                ease: "linear",
              }}
            >
              {[...clientLogos, ...clientLogos].map((logo, index) => (
                <motion.div
                  key={`col2-${index}`}
                  className="w-30 h-20 bg-white flex items-center justify-center shadow-md rounded-lg p-2"
                  whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                >
                  <Image
                    src={logo}
                    alt={`Client logo ${index + 1}`}
                    width={100}
                    height={60}
                    className="object-contain max-w-full max-h-full"
                  />
                </motion.div>
              ))}
            </motion.div>
          </div>

          <div className="w-1/3 h-96 md:h-[500px] overflow-hidden relative flex-1">
            <div className="absolute top-0 left-0 right-0 h-10 bg-gradient-to-b from-gray-100 to-transparent z-10"></div>
            <div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-gray-100 to-transparent z-10"></div>
            <motion.div
              className="flex flex-col items-center space-y-6"
              initial={{ y: 0 }}
              animate={{ y: "-50%" }}
              transition={{
                duration: 20,
                repeat: Infinity,
                repeatType: "loop",
                ease: "linear",
              }}
            >
              {[...clientLogos, ...clientLogos].map((logo, index) => (
                <motion.div
                  key={`col3-${index}`}
                  className="w-30 h-20 bg-white flex items-center justify-center shadow-md rounded-lg p-2"
                  whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                >
                  <Image
                    src={logo}
                    alt={`Client logo ${index + 1}`}
                    width={100}
                    height={60}
                    className="object-contain max-w-full max-h-full"
                  />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        {/* Right Side - Text and Person Image */}
        <div className="w-full md:w-3/5 lg:w-2/3 text-center md:text-left flex flex-col items-center md:items-start">
          <motion.h2
            className="text-white text-sm font-semibold mb-2"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            CONTACT US
          </motion.h2>

          <motion.h1
            className="text-xl md:text-xl lg:text-lg font-bold text-white mb-4 leading-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Partner with Us for Global Healthcare Logistics Supply
            Management…You can Trust On…!!
          </motion.h1>

          <motion.div
            className="flex flex-col lg:flex-row items-center justify-between gap-6 w-full"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="flex flex-col items-center md:items-start gap-4">
              <motion.button
                whileHover={{ scale: 1.05, backgroundColor: "#b91c1c" }}
                whileTap={{ scale: 0.95 }}
                className="bg-[#922D27] border border-white  text-white px-4 py-3 rounded-sm font-semibold text-md shadow-lg hover:shadow-xl transition-all duration-300"
              >
                GET IN TOUCH
              </motion.button>

              <p className="text-gray-200 max-w-md text-center md:text-left">
                Let's discuss how we can optimize your healthcare logistics
                supply chain with reliable, efficient solutions.
              </p>
            </div>

            <motion.div
              className="w-full lg:w-1/2 flex justify-center md:justify-end mt-4 lg:mt-0"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              viewport={{ once: true }}
            >
              {/* <div className="relative w-100 h-94 md:w-100 md:h-100">
                <Image
                  src="/assets/photos/home/local-distribution-boy.png"
                  alt="Healthcare logistics professional"
                  //   fill
                  className="object-contain rounded-lg shadow-lg"
                  //   sizes="(max-width: 768px) 256px, 320px"
                  width={500}
                  height={800}
                />
              </div> */}
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HomeGetInTouch;
